import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";
import {
  readEntityContentAnalytics,
  readEntityContentDetails,
  readEntityContentViewsAnalytics,
  readEntityContentViewsTrending,
  readEntityContentViewsDetails,
} from "./entityAnalyticsApi";
import {
  readEntityContentAnalyticsSuccess,
  readEntityContentAnalyticsFailure,
  readEntityContentDetailsSuccess,
  readEntityContentDetailsFailure,
  readEntityContentViewsAnalyticsSuccess,
  readEntityContentViewsAnalyticsFailure,
  readEntityContentViewsTrendingSuccess,
  readEntityContentViewsTrendingFailure,
  readEntityContentViewsDetailsSuccess,
  readEntityContentViewsDetailsFailure,
} from "./entityAnalyticsActions";

function* readEntityContentAnalyticsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readEntityContentAnalytics, apiPayloadRequest || {});
    yield put(readEntityContentAnalyticsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readEntityContentAnalyticsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readEntityContentDetailsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readEntityContentDetails, apiPayloadRequest || {});
    yield put(readEntityContentDetailsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readEntityContentDetailsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readEntityContentViewsAnalyticsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readEntityContentViewsAnalytics, apiPayloadRequest || {});
    yield put(readEntityContentViewsAnalyticsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readEntityContentViewsAnalyticsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readEntityContentViewsTrendingSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readEntityContentViewsTrending, apiPayloadRequest || {});
    yield put(readEntityContentViewsTrendingSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readEntityContentViewsTrendingFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

function* readEntityContentViewsDetailsSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(readEntityContentViewsDetails, apiPayloadRequest || {});
    yield put(readEntityContentViewsDetailsSuccess(data));
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data });
    }
  } catch (error) {
    yield put(readEntityContentViewsDetailsFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

export default function* entityAnalyticsWatcherSaga() {
  yield takeLatest(
    actionTypes.READ_ENTITY_CONTENT_ANALYTICS_REQUEST,
    readEntityContentAnalyticsSaga
  );
  yield takeLatest(
    actionTypes.READ_ENTITY_CONTENT_DETAILS_REQUEST,
    readEntityContentDetailsSaga
  );
  yield takeLatest(
    actionTypes.READ_ENTITY_CONTENT_VIEWS_ANALYTICS_REQUEST,
    readEntityContentViewsAnalyticsSaga
  );
  yield takeLatest(
    actionTypes.READ_ENTITY_CONTENT_VIEWS_TRENDING_REQUEST,
    readEntityContentViewsTrendingSaga
  );
  yield takeLatest(
    actionTypes.READ_ENTITY_CONTENT_VIEWS_DETAILS_REQUEST,
    readEntityContentViewsDetailsSaga
  );
}
